
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Select,
    Button,
    InputNumber
} from '../../ui/ot'
import { useTranslation } from "react-i18next";
import { Star, Edit, Trash2, History } from "lucide-react"

const BookReviewForm = ({
    keyPrefix = "library.reader_reviews",
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {}
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
        console.log({
            values
        })

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };

    const setFieldValue = (name, value) => {
        form.setValue(name, value);
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        let formValues = null;
        formValues = form.getFieldsValue();
    }, [formReloadCount]);
    useEffect(() => {
        // (propsForm ?? form).setFieldsValue({ ...defaultValue })
        setCount((pre) => pre + 1)
    }, [])

    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                // initialValues={initialValues}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}

                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    keyPrefix = "library.reader_reviews",
    field,
    initialValues = {},
    show,
    getAnyFormValue,
    count,
    setFieldValue,
    setCount
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <>
            <Row>
                <Col span={24}>
                    <div className="flex items-start space-x-4 py-4">
                        <div className="shrink-0">
                            <img
                                src={"https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=" +
                                    field?.bibitem_isbn}
                                alt={field?.bib_title}
                                className="h-[120px] w-[80px] rounded-md object-cover"
                            />
                        </div>
                        <div className="flex-1">
                            <h3 className="font-medium">{field?.bib_title}</h3>
                            <p className="text-sm text-muted-foreground">{field?.bib_author}</p>
                            <div className="mt-2 text-xs text-muted-foreground">
                                <div>{t('review_time')}: {(field?.create_time)}</div>
                                {field?.last_edit_time && (
                                    <div className="flex items-center mt-1">
                                        <History className="mr-1 h-3 w-3" />
                                        {t('last_edited')}: {(field?.last_edit_time)}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="space-y-4">
                        <div>
                            <label className="text-sm font-medium mb-2 block">{t('score')}</label>
                            <div className="flex space-x-1">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <button
                                        key={star}
                                        type="button"
                                        onClick={() => {
                                            setFieldValue([field?.name ?? '', 'star'].join('.'), star)
                                        }}
                                        className="focus:outline-none"
                                    >
                                        <Star
                                            className={`h-6 w-6 ${star <= getAnyFormValue([field?.name ?? '', 'star'].join('.'), count) ? "fill-[#e8a05c] text-[#e8a05c]" : "text-gray-300"
                                                }`}
                                        />
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div>
                            <Form.Item
                                {...field}
                                // label={t('old_password')}
                                label={t('rating')}
                                name={[field?.name ?? '', 'star']}
                                fieldKey={[field?.fieldKey, 'star']}
                                labelCol={24}
                                wrapperCol={24}
                                hidden={true}
                            >
                                <Input
                                    max={5}
                                    type="number"
                                />
                            </Form.Item>
                        </div>
                        <div>
                            <Form.Item
                                {...field}
                                // label={t('old_password')}
                                label={t('review_content')}
                                name={[field?.name ?? '', 'review_content']}
                                fieldKey={[field?.fieldKey, 'review_content']}
                                labelCol={24}
                                wrapperCol={24}
                            >
                                <Input.TextArea
                                    placeholder={t('enter_review_prompt')}
                                    className="min-h-[120px] border-[#e8e0d8]"

                                />
                            </Form.Item>
                        </div>
                    </div>
                </Col>


            </Row>
        </>
    );
};





export default BookReviewForm;
